import * as Yup from "yup";
import ProductModel from "../../models/products/product-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { Upload, UploadOnAddEvent } from '@progress/kendo-react-upload';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useEffect, useState } from "react";
import { useGetMainGroups } from "../../apiclient/product/useGetMainGroupApi";
import { useGetSubGroups } from "../../apiclient/product/useGetSubGroupApi";
import { useGetUoms } from "../../apiclient/product/useGetUOMApi";
import { SelectField } from "../../core/select-field.component";
import { useGetProducts } from "../../apiclient/product/useGetProductApi";
import { useGetProductTax } from "../../apiclient/master/useGetProductTaxApi";
import { FormikPage } from "../../core/formik-page-forms";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import "./products.scss"
import ImageUpload from "../../core/image-upload";
interface ProductEditProps {
    data: ProductModel;
    isViewMode?: boolean; 
    onClose?: (status: SubmitStatus, data: any) => any;
}

const ProductEntry: React.FC<ProductEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.productId > 0 ? "Edit Product" : "Add Product";

    let initialValue: ProductModel = {
        productId: data?.productId || 0,
        code: data?.code,
        hsnCode: data?.hsnCode,
        productName: data?.productName,
        productShortName: data?.productShortName,
        mainGroupId: data?.mainGroupId || 0,
        subGroupId: data?.subGroupId || 0,
        unitQty: data?.unitQty,
        unitFactor: data?.unitFactor,
        baseUnitId: data?.baseUnitId || 0,
        subUnitId: data?.subUnitId || 0,
        packetPerTray: data?.packetPerTray,
        printingOrder: data?.printingOrder,
        productTaxId: data?.productTaxId || 0,
        baseRate: data?.baseRate,
        cgstRate: data?.cgstRate,
        sgstRate: data?.sgstRate,
        igstRate: data?.igstRate,
        netRate: data?.netRate,  
        cardRate: data?.cardRate,
        freeRate: data?.freeRate,
        literPerCrate: data?.literPerCrate,
        specialOrderRate: data?.specialOrderRate,
        isActive: data?.productId > 0 ? data.isActive : true,
        isIndent: data?.isIndent ?? true,
        isCard: data?.isCard,
        isFree: data?.isFree,
        isSpecialOrder: data?.isSpecialOrder,
        isCan: data?.isCan,
        isUnitRate: data?.isUnitRate,
        isCommission: data?.isCommission,
        imageFilePath: data?.imageFilePath,
        minimumOrderQuantity: data?.minimumOrderQuantity,
        maximumOrderQuantity: data?.maximumOrderQuantity,
        orderinMultiplesOf: data?.orderinMultiplesOf,
        wrapperWeight: data?.wrapperWeight,
        productWeight: data?.productWeight
    };
    console.log(initialValue)
    const validationSchema = Yup.object().shape({
        productName: Yup.string().required("Required"),
        productShortName: Yup.string().required("Required"),
       // mainGroupId: Yup.number().min(1, "Main Group is required").required("Main Group is required"),
        unitFactor: Yup.string().required("Required"),
      //  subGroupId: Yup.number().min(1, "Sub Group is required").required("Sub Group is required"),
        baseUnitId: Yup.number().min(1, "Base Unit is required").required("Base Unit is required"),
        subUnitId: Yup.number().min(1, "Sub Unit is required").required("Sub Unit is required"),
        baseRate: Yup.string().required("Required"),

        code: Yup.string()
            .required(" Code is required")
            .test("check-duplicate-code", " Code already exists", (value) => {
                // Check if the employeeCode already exists in the list of existing codes
                return !existingCode.includes(value) ||
                    (data?.code && value === data.code) // Allow current name during update
            }),

    });

    const [image, setImage] = useState<File | null>(null);
    const [files, setFiles] = useState<any[]>([]);
    const onAdd = (event: UploadOnAddEvent) => {
        // Get the raw file object from the affected files
        const file = event.affectedFiles[0].getRawFile();
        setImage(file); // Set the file for preview or further processing
        setFiles(event.newState); // Update the list of files
    };
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [existingCode, setExistingCode] = useState<string[]>([]);
    const { data: fetchedProduct } = useGetProducts();

    const [mainGroupData, setMainGroupData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedMainGroup } = useGetMainGroups();
    const [subGroupData, setSubGroupData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedSubGroup } = useGetSubGroups();
    const [uomData, setUOMData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedUOM } = useGetUoms();
    const [productTaxData, setProductTaxData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedProductTax } = useGetProductTax();

    useEffect(() => {

        if (fetchedProduct) {
            // Extract employee codes and PAN numbers from the fetched data
            setExistingCode(fetchedProduct.map((emp: any) => emp.code));
        }

        if (fetchedMainGroup) {
            const mappedmaingroup = fetchedMainGroup.map((maingroup: any) => ({
                value: maingroup.mainGroupId,
                label: maingroup.name,
            }));

            setMainGroupData(mappedmaingroup);
        }

        if (fetchedSubGroup) {
            const mappedsubgroup = fetchedSubGroup.map((subgroup: any) => ({
                value: subgroup.subGroupId,
                label: subgroup.name,
            }));
            setSubGroupData(mappedsubgroup);
        }

        if (fetchedUOM) {
            const mappeduom = fetchedUOM.map((uom: any) => ({
                value: uom.uomId,
                label: uom.name,
            }));
            setUOMData(mappeduom);
        }

        if (fetchedProductTax) {
            const mappedproducttax = fetchedProductTax.map((producttax: any) => ({
                value: producttax.productTaxId,
                label: producttax.taxName,
            }));
            setProductTaxData(mappedproducttax);
        }
    }, [fetchedMainGroup, fetchedProductTax, fetchedUOM, fetchedSubGroup, fetchedProduct]);
    return (
        <FormikModelDialog
          width="80%" // Make the modal full width
          title={title}
          initialData={initialValue}
          validationSchema={validationSchema}
          show={!!data}
          onClose={onClose}
          endpoint={API_END_POINT.PRODUCT}
          postRoute="Product/SaveProduct"
          showAddAnother={true}
          isViewOnly ={isViewMode}
          isUpDateEntityDetails={data?.productId > 0}
        >
          <div className="bg-white-head tabwhitespace" style={{ width: "100%" }}>
            <TabStrip
              selected={selectedTab}
              onSelect={(e) => {
                setSelectedTab(e.selected);
              }}
              className="mx-2 mt-3 mb-3 bg-light"
              style={{ minHeight: "35vh", minWidth: "42vw" }}
            >
              <TabStripTab contentClassName="structureTab" title="Product Detail">
                <div className="group-container m-2">
                  <div className="row">
                    <div className="col-md-3">
                      <InputField maxLength={50} label="Code*" name="code" />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Product Name*"
                        name="productName"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Product Short Name*"
                        name="productShortName"
                      />
                    </div>
                    <div className="col-md-3">
                      <SelectField
                        label="Main Group*"
                        name="mainGroupId"
                        options={mainGroupData}
                      />
                    </div>
                    <div className="col-md-3">
                      <SelectField
                        label="Sub Group*"
                        name="subGroupId"
                        options={subGroupData}
                      />
                    </div>
                    <div className="col-md-3">
                      <SelectField
                        label="Base Unit*"
                        name="baseUnitId"
                        options={uomData}
                      />
                    </div>
                    <div className="col-md-3">
                      <SelectField
                        label="Sub Unit*"
                        name="subUnitId"
                        options={uomData}
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Unit Qty"
                        name="unitQty"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Unit Factor*"
                        name="unitFactor"
                      />
                    </div>
                    {/* Image Upload */}
                    <div className="col-md-6 d-flex align-items-center">
                      {/* Active Checkbox */}
                      <CheckboxField
                        label="Active?"
                        name="isActive"
                        checkstyle={CheckBoxStyle.Normal}
                      />
                    </div>
                  </div>
                </div>
              </TabStripTab>
              <TabStripTab contentClassName="structureTab" title="Price Detail">
                <div className="m-2">
                  <div className="row">
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Printing Order"
                        name="printingOrder"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Min. Order Qty"
                        name="minimumOrderQuantity"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Max. Order Qty"
                        name="maximumOrderQuantity"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Packet Per Tray"
                        name="packetPerTray"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Order In Multiples Of"
                        name="orderinMultiplesOf"
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-wrap ms-1 align-items-center">
                    <CheckboxField
                      label="Indent?"
                      name="isIndent"
                      checkstyle={CheckBoxStyle.Normal}
                    />
                    <div className="ms-4"></div>
                    <CheckboxField
                      label="Special Order?"
                      name="isSpecialOrder"
                      checkstyle={CheckBoxStyle.Normal}
                    />
                    <div className="ms-4"></div>
                    <CheckboxField
                      label="Commission?"
                      name="isCommission"
                      checkstyle={CheckBoxStyle.Normal}
                    />
                    <div className="ms-4"></div>
                    <CheckboxField
                      label="Card?"
                      name="isCard"
                      checkstyle={CheckBoxStyle.Normal}
                    />
                    <div className="ms-4"></div>
                    <CheckboxField
                      label="Free?"
                      name="isFree"
                      checkstyle={CheckBoxStyle.Normal}
                    />
                    <div className="ms-4"></div>
                    <CheckboxField
                      label="Can?"
                      name="isCan"
                      checkstyle={CheckBoxStyle.Normal}
                    />
                  </div>
                </div>
              </TabStripTab>
              <TabStripTab contentClassName="structureTab" title="Product Price ">
                <div className="m-2">
                  <div className="row">
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Base Rate"
                        name="baseRate"
                      />
                    </div>
                    <div className="col-md-3">
                    <SelectField
                        label="Product Tax*"
                        name="productTaxId"
                        options={productTaxData}
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="HSN Code"
                        name="hsnCode"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="IGST Rate"
                        name="igstRate"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="CGST Rate"
                        name="cgstRate"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="SGST Rate"
                        name="sgstRate"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Net Rate"
                        name="netRate"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Free Milk Rate"
                        name="freeRate"
                      />
                    </div>
                    <div className="col-md-3">
                      <InputField
                        maxLength={50}
                        label="Special Order Rate"
                        name="specialOrderRate"
                      />  
                    </div>
                  </div>                
                </div>
              </TabStripTab>
              <TabStripTab contentClassName="structureTab" title="Picture">
                <div className="row col-12">
                  <div className="col-6ms-auto">
                    <label>Product Image</label>
                    <ImageUpload></ImageUpload> 
                  </div>

                </div>
              </TabStripTab>
            </TabStrip>
          </div>
        </FormikModelDialog>
    );
};

export default ProductEntry;